<template>
  <div class="videosetting">
    <div class="list">
      <van-cell >
        <div class="container">
          <div class="upload-button" @click="showAddImg">
            <img src="/static/images/program/updata.png" alt="Upload" class="upload-icon">
          </div>
          <div class="scrollable-list">
            <div class="list-item" v-for="(item, index) in lists" :key="index">
              <div class="delete-button" @click="dele(index)">
                <img src="/static/images/program/del.png">
              </div>
              <img v-if="item.type==='video'" :src="getUrl(item.viewUrl)"  @error="errImg($event, item)"  class="item-image">
              <img v-else :src="getUrl(item.screenshotUrl?item.screenshotUrl:item.url)"  @error="errImg($event, item)" class="item-image">
            </div>
          </div>
        </div>
      </van-cell>
      <van-cell >
        <template #icon>
          <img src="/static/images/program/volume.png" style="height: 25px;margin-right: 10px">
        </template>
        <span>{{$t('append_field.volume')}}</span>
        <div style="float: right;">
          <van-stepper v-model="volume" min="0" integer max="100" @change="setrolletime"></van-stepper>
        </div>
      </van-cell>
      <van-cell >
        <template #icon>
          <img src="/static/images/program/unifyTime.png" style="height: 25px;margin-right: 10px">
        </template>
        <span>{{$t('append_field.pub_toggle_time')}}</span>
        <div style="float: right;">
          <van-stepper v-model="unifyTime" @change="unify" min="3"/>
        </div>
      </van-cell>
<!--      <van-cell @click="effectSwitch">
        <template #icon>
          <img src="/static/images/program/effectSwitch.png" style="height: 25px;margin-right: 10px">
        </template>
        <span>{{$t('append_field.toggle_effect')}}</span>
        <div style="float: right;">
          {{ cartoonName }}
          <van-icon name="arrow"/>
        </div>
      </van-cell>-->
    </div>
    <van-dialog
        v-model="showActionSheet"
        :title="$t('append_field.toggle_effect')"
        show-cancel-button
        @confirm="onSelectEffect"
        @cancel="showActionSheet = false"
        class="select-groupings"
    >
      <div class="radio-group">
        <van-radio-group v-model="selectedEffectId">
          <van-cell-group>
            <van-cell
                v-for="(exercise, index) in exerciseTypes"
                clickable
                :key="index"
                @click="selectExercise(exercise.id)"
                :title="exercise.name"
            >
              <template #right-icon>
                <van-radio :name="exercise.id" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>
    <addMixture v-if="isMixture" @setMixture="setMixture" @close="close"></addMixture>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import addMixture from "@/components/addMixture.vue";

  export default {
    props: {
      lists: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        volume: 70,
        period: false,
        isMixture: false,
        i: '1',
        unifyTime: 10,
        effect: false,
        showActionSheet: false,
        selectedEffect: null,
        selectedEffectId: '1', // 用于跟踪选中的选项
        cartoonName:'',
        exerciseTypes: [
          {
            'id': '1',
            'name': this.$t('append_field.defaultEffect'),
          },
          {
            'id': '2',
            'name': this.$t('append_field.rightToLeft'),
          },
          {
            'id': '3',
            'name': this.$t('append_field.leftToRight'),
          },
          {
            'id': '4',
            'name': this.$t('append_field.topToBottom'),
          },
          {
            'id': '5',
            'name': this.$t('append_field.bottomToTop'),
          },
          {
            'id': '6',
            'name': this.$t('append_field.accordionSqueeze'),
          },
          {
            'id': '7',
            'name': this.$t('append_field.zoomInFade'),
          },
          {
            'id': '8',
            'name': this.$t('append_field.zoomOutFade'),
          },
          {
            'id': '9',
            'name': this.$t('append_field.dIn'),
          },
          {
            'id': '10',
            'name': this.$t('append_field.dOut'),
          },
          {
            'id': '11',
            'name': this.$t('append_field.depthOfField'),
          },
          {
            'id': '12',
            'name': this.$t('append_field.leftRightRotate'),
          },
          {
            'id': '13',
            'name': this.$t('append_field.upDownRotate'),
          },
          {
            'id': '14',
            'name': this.$t('append_field.counterclockwiseRotate'),
          },
          {
            'id': '15',
            'name': this.$t('append_field.clockwiseRotate'),
          },
          {
            'id': '16',
            'name': this.$t('append_field.upDownZoom'),
          },
          {
            'id': '17',
            'name': this.$t('append_field.dxiao'),
          },
          {
            'id': '18',
            'name': this.$t('append_field.scaleFade'),
          }, {
            'id': '19',
            'name': this.$t('append_field.zoomInDisappearing'),
          }, {
            'id': '20',
            'name': this.$t('append_field.transparentFade'),
          }, {
            'id': '21',
            'name': this.$t('append_field.gradientScale'),
          },
        ].map(effect => ({
          ...effect,
        })),
      }
    },
    mounted() {
      if(this.lists[0]){
        this.volume=this.lists[0].volume
        this.unifyTime= this.lists[0].playParam
      }
      this.componentsList[this.controlIndex].mpList.map(res => {
        this.selectedEffectId = res.cartoon
      })
      this.onSelectEffect()
    },
    methods: {
      ...mapActions(['addMixture']),
      fullscreen() {
        this.$emit('fullscreen')
      },
      setrolletime: function (value) {
        this.componentsList[this.controlIndex].mpList.map(res => {
          res.volume = value
        })
      },
      replace() {
        this.$emit('addVideo')
      },
      dele(index) {
        this.$emit('ondele', index)
      },
      showAddImg() {
        this.isMixture = true
      },
      setMixture(data) {
        this.addMixture(data)
        this.isMixture = false
      }
      ,
      close() {
        this.isMixture = false
      },
      clear() {
        this.$emit('clear')
      },
      unify(val) {
        this.componentsList[this.controlIndex].mpList.map(res => {
          res.playParam = val
        })
      },
      effectSwitch() {
        this.showActionSheet = true
        this.componentsList[this.controlIndex].mpList.map(res => {
          this.i = parseInt(res.cartoon)
        })
      },
      toggle(index){
        this.$refs.checkboxes[index].toggle()
      },
      onSelectEffect() {
        const selectedEffect = this.exerciseTypes.find(effect => effect.id === this.selectedEffectId)
        this.cartoonName = selectedEffect ? selectedEffect.name : '';
        this.componentsList[this.controlIndex].mpList.map(res => {
          res.cartoon = selectedEffect.id
        })
        this.showActionSheet = false; // 关闭操作表
      },
      selectExercise(id){
        this.selectedEffectId=id
      },
      getUrl(url){
        if(!url){
          return '/static/images/icon_loader_failed_braseas.png'
        }
        const isHttpUrl = url.startsWith("http")
        if (isHttpUrl) {
          return url
        }

        // 如果不是 HTTP URL，拼接基础 URL 并返回
        return this.upFileUrl + url
      },
      errImg(event) {
        event.target.src = '/static/images/icon_loader_failed_braseas.png'; // 设置错误图片
      },
    },
    components: {addMixture},
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .videosetting {
    .list {
      .van-cell ,.van-cell__value{
        display:flex ;
        align-items: center;
        justify-content: space-between;
      }
    }
    .container {
      display: flex;
      //height:60px;
      width: 100%;
    }

    .upload-button {
      position: sticky;
      left: 0;
      top: 0;
      width: 40px;
      height: 40px;
      background-color: white; /* 防止内容滚动时覆盖 */
      padding: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
     /* border: 2px solid #ccc;
      border-radius: 5px; !* 圆角边框 *!*/
    }

    .upload-icon {
      width: 65px;
      height: 65px;
    }

    .scrollable-list {
      width: calc(100% - 50px);
      display: flex;
      overflow-x: auto;
      margin-left: 10px; /* 为了避免与固定的上传按钮重叠 */
    }

    .list-item {
      position: relative; /* 使得内部的绝对定位元素相对于该元素定位 */
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 10px;
    }

    .delete-button {
      align-self: flex-end;
      cursor: pointer;
      position: absolute; /* 绝对定位 */
      top: 2px; /* 距离顶部5px */
      right: 2px;
      img{
        width: 20px;
        height: 20px;
      }
    }

    .item-image {
      height: 60px;
      width: 60px;
      /*border-radius: 30px;*/
    }

    .item-details {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }

    .videosetting-tab {
      display: flex;
      width: 100%;
      height: 50px;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 30;
      background: #FFFFFF;

      .control-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 50px;

        .control-item-title {
          font-size:  15px;
        }

        .control-item-icon {
        }
      }

      .control-item-animation-font {
        position: fixed;
        width: 100%;
        bottom: -100px;
        left: 0;
        height: 50px;
        background: $uni-border-bottom-color;
        transition: bottom 1s;
        display: flex;
        align-items: center;
        justify-content: center;

        .control-item-view {
          height: 25px;
          line-height: 25px;
          min-width: 100px;
          font-size:  15px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-left: 2 upx solid $uni-text-color-placeholder;
          color: $uni-text-color-inverse;
        }

        .control-item-view:nth-of-type(1) {
          border-left: none;
        }
      }

      .effect-show {
        bottom: 50px;
      }
    }
    .select-groupings{
      height: 60%;
      .van-dialog__content{
        //margin: 10px 0;
        height: calc(100% - 48px - 48px );
        overflow-y: auto;
      }
    }

  }


</style>
